// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oc5fV_fd18 {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.oc5fV_fd18 h4 {
  line-height: 3em;
}
.oc5fV_fd18 .aJh67mOfcG {
  float: left;
  width: 100%;
}
.oc5fV_fd18 .LIncqPCAlS {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.oc5fV_fd18 .LIncqPCAlS:hover {
  cursor: pointer;
}
.oc5fV_fd18 .LIncqPCAlS:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.IPV9W56YIO .n9YHVwwe9N:focus {
  outline: none;
}
.IPV9W56YIO .n9YHVwwe9N.bkX32PFmCh.hrSusPBc7y {
  background: #375A88;
}
.IPV9W56YIO .n9YHVwwe9N.bkX32PFmCh.hrSusPBc7y span {
  color: #fff;
}
.IPV9W56YIO .hrSusPBc7y {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.IPV9W56YIO .hrSusPBc7y:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.IPV9W56YIO input {
  height: 38px;
  min-width: 220px;
}
.LIncqPCAlS.quv28Aw5S9 {
  background: #410102;
}
.LIncqPCAlS.XV_k3E0MnJ {
  background: #911318;
}
.LIncqPCAlS.awtKq_A3Zx {
  background: #D8293B;
}
.LIncqPCAlS.uiH8QVKaMn {
  background: #F2373C;
}
.LIncqPCAlS.t727p4DDOy {
  background: #FC4448;
}
.LIncqPCAlS.fejtiNxgZH {
  background: #ED535E;
}
.LIncqPCAlS.u7Qhbeft2T {
  background: #E34926;
}
.LIncqPCAlS.VJ134T0wdg {
  background: #FC562B;
}
.LIncqPCAlS.zkWFUNE07b {
  background: #FC6722;
}
.LIncqPCAlS.S9WycoQOxu {
  background: #FD7F24;
}
.LIncqPCAlS.ZA_ZTsjZdu {
  background: #FD8D26;
}
.LIncqPCAlS.Bh2CY96sL6 {
  background: #EC9C3E;
}
.LIncqPCAlS.AdrrvXxs5T {
  background: #0e673a;
}
.LIncqPCAlS.vuvtYQlsob {
  background: #208740;
}
.LIncqPCAlS.wQJ1rH9o18 {
  background: #239718;
}
.LIncqPCAlS.VH4VrJHuvd {
  background: #55A84D;
}
.LIncqPCAlS.TL67Q9VGZx {
  background: #4BBE5A;
}
.LIncqPCAlS.oV0EAM2HQD {
  background: #0CCA6A;
}
.LIncqPCAlS.CrqosgFB1X {
  background: #0A3C64;
}
.LIncqPCAlS.PAEpX_68AC {
  background: #0d487a;
}
.LIncqPCAlS.oKUEJAwYCJ {
  background: #10538d;
}
.LIncqPCAlS.Wfoeo0mLhq {
  background: #115A99;
}
.LIncqPCAlS.JLNhsp4ocF {
  background: #3387E2;
}
.LIncqPCAlS.PZir3AZ7l6 {
  background: #1BA9CF;
}
.LIncqPCAlS.W_blNLsFhP {
  background: #d27c02;
}
.LIncqPCAlS.SaVdtZE7Rk {
  background: #fb9402;
}
.LIncqPCAlS.mR_1Kyp94F {
  background: #FD9B30;
}
.LIncqPCAlS.R_w9w7fA8f {
  background: #FDBE2D;
}
.LIncqPCAlS.wI6u141jkI {
  background: #FED831;
}
.LIncqPCAlS.sty3Hd3Zeh {
  background: #FFFD38;
}
.LIncqPCAlS.LvgeyQdtbx {
  background: #2D215C;
}
.LIncqPCAlS.qSVnNktME5 {
  background: #483C83;
}
.LIncqPCAlS.h47QW1ZybV {
  background: #58518d;
}
.LIncqPCAlS.CtPEsi_GN7 {
  background: #7068A9;
}
.LIncqPCAlS.esOpg9Vdqs {
  background: #7f78b2;
}
.LIncqPCAlS.zRZijbXPLJ {
  background: #8f88bc;
}
.LIncqPCAlS.vh6gRIfqZT {
  background: #000;
}
.LIncqPCAlS.u8OfCRbpPt {
  background: #282626;
}
.LIncqPCAlS.rcJCR3HJXc {
  background: #242222;
}
.LIncqPCAlS.J3sVeYVaHe {
  background: #353838;
}
.LIncqPCAlS.tTq08FPXZ4 {
  background: #666;
}
.LIncqPCAlS._nEN7V3MnR {
  background: #999;
}
.JpwHN2aUFQ {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.JpwHN2aUFQ .yNgfo0aRAq {
  display: none;
}
.o_TQDX7Ppq {
  display: flex;
  position: relative;
  min-height: 78vh;
  gap: 16px;
}
.SGiRjqk3bp {
  width: 232px;
  flex-shrink: 0;
  height: 100%;
  display: flex;
  gap: 20px;
  flex-direction: column;
}
.jskPYO0LUA {
  display: flex;
  flex-direction: column;
  -webkit-font-smoothing: antialiased;
}
.OaFWPl0BP0 {
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  align-items: center;
  padding: 12px 16px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  height: 56px;
  border-bottom: 1px solid #E4E4E6;
}
.RO_s3xsq1b {
  font-family: Lato;
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0%;
  color: #626166;
}
.jS52coMl24 {
  font-family: Lato;
  font-weight: 700;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 10%;
  text-transform: uppercase;
  color: #18181A;
  letter-spacing: 0.1em;
}
.TUhB8ASWfo {
  flex-grow: 1;
  overflow-x: hidden;
  border: 1px solid #CAC9CC;
  border-radius: 4px;
  height: 100%;
}
.TUhB8ASWfo .b-label.b-align-start {
  color: #616161 !important;
}
.TUhB8ASWfo .b-field-inner.b-field-inner {
  border-color: #d0d1d2 !important;
}
.TUhB8ASWfo .b-field-inner.b-field-inner:disabled {
  border-color: #d0d1d2 !important;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `oc5fV_fd18`,
	"color-row": `aJh67mOfcG`,
	"color-tile": `LIncqPCAlS`,
	"picker-component": `IPV9W56YIO`,
	"picker-element": `n9YHVwwe9N`,
	"active": `bkX32PFmCh`,
	"btn": `hrSusPBc7y`,
	"red-1": `quv28Aw5S9`,
	"red-2": `XV_k3E0MnJ`,
	"red-3": `awtKq_A3Zx`,
	"red-4": `uiH8QVKaMn`,
	"red-5": `t727p4DDOy`,
	"red-6": `fejtiNxgZH`,
	"orange-1": `u7Qhbeft2T`,
	"orange-2": `VJ134T0wdg`,
	"orange-3": `zkWFUNE07b`,
	"orange-4": `S9WycoQOxu`,
	"orange-5": `ZA_ZTsjZdu`,
	"orange-6": `Bh2CY96sL6`,
	"green-1": `AdrrvXxs5T`,
	"green-2": `vuvtYQlsob`,
	"green-3": `wQJ1rH9o18`,
	"green-4": `VH4VrJHuvd`,
	"green-5": `TL67Q9VGZx`,
	"green-6": `oV0EAM2HQD`,
	"blue-1": `CrqosgFB1X`,
	"blue-2": `PAEpX_68AC`,
	"blue-3": `oKUEJAwYCJ`,
	"blue-4": `Wfoeo0mLhq`,
	"blue-5": `JLNhsp4ocF`,
	"blue-6": `PZir3AZ7l6`,
	"yellow-1": `W_blNLsFhP`,
	"yellow-2": `SaVdtZE7Rk`,
	"yellow-3": `mR_1Kyp94F`,
	"yellow-4": `R_w9w7fA8f`,
	"yellow-5": `wI6u141jkI`,
	"yellow-6": `sty3Hd3Zeh`,
	"purple-1": `LvgeyQdtbx`,
	"purple-2": `qSVnNktME5`,
	"purple-3": `h47QW1ZybV`,
	"purple-4": `CtPEsi_GN7`,
	"purple-5": `esOpg9Vdqs`,
	"purple-6": `zRZijbXPLJ`,
	"black-1": `vh6gRIfqZT`,
	"black-2": `u8OfCRbpPt`,
	"black-3": `rcJCR3HJXc`,
	"black-4": `J3sVeYVaHe`,
	"black-5": `tTq08FPXZ4`,
	"black-6": `_nEN7V3MnR`,
	"picker-theme": `JpwHN2aUFQ`,
	"arrow-regular": `yNgfo0aRAq`,
	"review-component": `o_TQDX7Ppq`,
	"review-component__reviewList": `SGiRjqk3bp`,
	"review-component__title-ctn": `jskPYO0LUA`,
	"review-component__reviewHeader": `OaFWPl0BP0`,
	"review-component__reviewsFilter": `RO_s3xsq1b`,
	"review-component__reviewsTitle": `jS52coMl24`,
	"review-component__reviewGrid": `TUhB8ASWfo`
};
export default ___CSS_LOADER_EXPORT___;
